import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
import List from './List.vue';
import Edit from './Edit.vue';
import { mapGetters, mapActions } from 'vuex';
export default {
  components: {
    List: List,
    Edit: Edit
  },
  data: function data() {
    return {
      isShowList: true,
      isShowEdit: false
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions('DeliveryNote/DnbarcodeHandmade', ['setOrderStatu'])), {}, {
    handleBlackBtn: function handleBlackBtn() {
      this.setOrderStatu('listShow');
      this.$refs.List.getLoadData();
    },
    onHandleEdit: function onHandleEdit(data) {
      this.$refs.Edit.setData(data);
    }
  }),
  watch: {
    $DnbarcodeHandmadeState: {
      handler: function handler(nawValue) {
        // console.log('单据操作状态==>',nawValue);
        if (nawValue === 'listShow') {
          // 订单列表
          this.isShowList = true;
          this.isShowEdit = false;
        } else if (nawValue === 'addOrder') {
          // 新增订单
          this.isShowList = false;
          this.isShowEdit = true;
        } else if (nawValue === 'orderShow') {
          // 订单明细
          this.isShowList = false;
          this.isShowEdit = true;
        } else if (nawValue === 'editOrder') {}
      },
      immediate: true
    }
  },
  computed: _objectSpread({}, mapGetters(['$DnbarcodeHandmadeState']))
};